import { render } from "./Pdf.vue?vue&type=template&id=2ba08ae4&scoped=true"
import script from "./Pdf.vue?vue&type=script&lang=js"
export * from "./Pdf.vue?vue&type=script&lang=js"

import "./Pdf.vue?vue&type=style&index=0&id=2ba08ae4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ba08ae4"]])

export default __exports__